import { useMemo } from 'react'
import { useQuery } from "@apollo/client";
import { BALANCE } from "src/graphql/queries/balance";
import { balanceQuery } from "src/types/balance-types";
import { investorAccountType } from "src/types/investor-account-types";

const useQueryBalance = (investorAccount:investorAccountType | undefined | null) => {
  const { data: Balance , ...prop } = useQuery<balanceQuery>(BALANCE, {
		variables: {
			investorAccountID: investorAccount?.investorAccountID,
		},
		skip: !investorAccount?.investorAccountID,
	});

	//cache ...
	const balance = useMemo(() => {
		if (Balance?.balance?.__typename === "BalanceOutput") {
			return Balance.balance;
		} else return undefined;
	}, [Balance]);

  return {
    ...prop,
    data:balance,
  }
}

export default useQueryBalance